const defaultServiceName = 'identityplus';

export const analyticsServiceName =
  process.env.REACT_APP_SERVICE_NAME ?? defaultServiceName;
